// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CaretRightOutlinedSvg from "@fishx/icons-svg/es/asn/CaretRightOutlined";
import FishxIcon from '../components/FishxIcon';

var CaretRightOutlined = function CaretRightOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CaretRightOutlinedSvg
  }));
};

CaretRightOutlined.displayName = 'CaretRightOutlined';
export default React.forwardRef(CaretRightOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CaretRightOutlined.js
// module id = 2178
// module chunks = 0